import { fmt } from 'components/IntlWrapper/IntlWrapper';

const commonConnectionPluginStepOneItems = [
  {
    id: 2,
    title: fmt({ id: 'chats_plugins.install_plugins.share_and_sell' })
  },
  {
    id: 3,
    title: fmt({ id: 'chats_plugins.install_plugins.collect_with_bot' })
  }
];

export const CONNECTION_PLUGINS_STEP_ONE = {
  MESSENGER: [
    {
      id: 1,
      title: fmt({ id: 'chats_plugins.install_plugins.recive_reply_to_fb' })
    },
    ...commonConnectionPluginStepOneItems
  ],
  WHATSAPP: [
    {
      id: 1,
      title: fmt({ id: 'chats_plugins.install_plugins.recive_reply_to_fb' })
    },
    ...commonConnectionPluginStepOneItems
  ],
  INSTAGRAM: [
    {
      id: 1,
      title: fmt({
        id: 'chats_plugins.install_plugins.recive_reply_to_fb_instagram'
      })
    },
    ...commonConnectionPluginStepOneItems
  ]
};

//data will be updated
export const CONNECTION_PLUGINS_STEP_TWO = {
  MESSENGER: [
    {
      id: 1,
      title: fmt({ id: 'chats_plugins.install_plugins.give_sllr_permissions' })
    },
    {
      id: 2,
      title: fmt({
        id: 'chats_plugins.install_plugins.select_bussiness_and_page'
      })
    }
  ],
  WHATSAPP: [
    {
      id: 1,
      title: fmt({ id: 'chats_plugins.install_plugins.give_sllr_permissions' })
    },
    {
      id: 2,
      title: fmt({
        id: 'chats_plugins.install_plugins.select_bussiness_and_page'
      })
    },
    {
      id: 3,
      title: fmt({ id: 'chats_plugins.install_plugins.add_fb_webhook' })
    }
  ],
  INSTAGRAM: [
    {
      id: 1,
      title: fmt({
        id: 'chats_plugins.install_plugins.give_sllr_permissions_instagram'
      })
    },
    {
      id: 2,
      title: fmt({
        id: 'chats_plugins.install_plugins.select_bussiness_and_page_instagram'
      })
    },
    {
      id: 3,
      title: fmt({ id: 'chats_plugins.install_plugins.add_instagram_webhook' })
    }
  ]
};

export const DISCONNECT_PLUGIN = [
  {
    id: 1,
    title: fmt({
      id: 'chats_plugins.install_plugins.will_not_be_able_to_chat_with_your_customers'
    })
  },
  {
    id: 2,
    title: fmt({
      id: 'chats_plugins.install_plugins.lose_all_active_chats'
    })
  }
];
